import { FC, ReactNode } from "react";
import styles from "./Button1.module.css";

interface Props {
  children: ReactNode;
  className?: string;
}

export const Button1: FC<Props> = ({ children, className = "" }) => {
  return <p className={`${styles.button1} ${className}`}>{children}</p>;
};
